<template>
  <div class="app2">
	<div class="content-nav" v-for="item in list" @click="goPage(item)">
        <div class="content-nav-card">
            <div>
                <img :src="item.user" alt="">
            </div>
            <div>
                <h3>{{item.name}}</h3>
                <p>{{item.ygzdw}}</p>
                <p>{{item.zw}}</p>
                <div class="bq">
                    <span>{{item.zzmm_dictText}}</span>
                    <span v-if="item.zyly_dictText">{{item.zyly_dictText}}</span>
                    <span v-if="item.byyx">{{item.byyx}}</span>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker,Dialog } from 'vant'
export default {
	props: {
		list: {
		type: Array,
            default() {
                return []
            },
		},
	},
	data(){
		return{
		}
	},
	mounted() {

	},
	methods:{
		goPage(e){
			sessionStorage.setItem('zjzxId',e.id)
			this.$router.push({
				name:"zyzx_detail",
				params:{
					type:1,
					id:e.id
				}
			})
		}
	}
}
</script>

<style scoped lang="less">
.app{
	width: 100%;
	min-height: 100vh;
	background-color: white;
}
p{
	margin: 0px;
	padding: 0px;
}
h3{
	margin: 0px;
}
input{
	border: none
}
.content{
	padding: 0px;
	font-size: 16px;
	box-sizing: border-box;
	&-nav{
		width: 100%;
		// height: 100px;
		border-radius: 4px;
		background: white;
		padding: 10px 0px;
		border-bottom: 1px solid #F4F4F4;
		&-card{
			padding: 10px 10px;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			>div:first-child{
				width: 24%;
				height: 80px;
				img{
                    height: 100%;
					border-radius: 4px;
				}
			}
			>div:last-child{
				width: 74%;
				height: 100%;
				margin: 0px 0px;
				h3{
					
				}
				p{
					font-size: 14px;
					color: #666666;
					margin: 4px 0px;
				}
				.bq{	
					display: flex;
					flex-wrap: wrap;
					span{
						font-size: 12px;
						color:#9D9D9D;
						background: #F3F3F4;
						border-radius: 4px;
						padding: 2px 4px;
						margin: 0px 4px 8px 0px;
					}
					span:last-child{
						margin: 0px 0px 8px 0px;
					}
				}
			}
		}
	}
}
</style>